import Vue from "vue";
import Router from "vue-router";
import store from "../store"
import {UserService} from "@/common/api.service"
import Registration from "../views/Registration";
import AccountBlocked from "../views/AccountBlocked";
import Login from "../views/Login";
import ForgotPassword from "../views/ForgotPassword";
import PasswordExpired from "../views/PasswordExpired";
import ThankYouForRegistering from "../views/ThankYouForRegistering";
import PasswordReset from "../views/PasswordReset";
import RegistrationAndLoginSupport from "../views/RegistrationAndLoginSupport";
import PasswordResetConfirm from "../views/PasswordResetConfirm";
import RegistrationAndLoginError from "../views/RegistrationAndLoginError";
import Dashboard from "../views/Dashboard";
import MyDocuments from "../views/MyDocuments";
import MyAdmin from "../views/MyAdmin";
import MyAccount from "../views/MyAccount";
import Support from "../views/Support";
import MySubscription from "../views/MySubscription";
import MyParametricSearch from "../views/parametric-search/MyParametricSearch";
import MyParametricTable from "../views/parametric-search/MyParametricTable";
import MyParametricDriver from "../views/parametric-search/MyParametricDriver";
import MyParametricCompare from "../views/parametric-search/MyParametricCompare";
import MyParametricDemo from "../views/parametric-search/MyParametricDemo";
import Utils from "../common/utils";
import {LOGOUT_USER} from "@/store/actions.type";
import RegistrationAndLoginSupportSuccess from "../views/RegistrationAndLoginSupportSuccess";
import RegistrationAndLoginSupportError from "../views/RegistrationAndLoginSupportError";

Vue.use(Router);

let router = new Router({
    routes: [
        {
            path: "/",
            name: "login-page",
            component: Login,
            props: true,
            meta: {
                title: "Login"
            }
        },
		{
			path: "/account-blocked",
			name: "account-blocked-page",
			component: AccountBlocked,
			meta: {
				title: "AccountBlocked"
			}
		},
		{
            path: "/registration",
            name: "registration-page",
            component: Registration,
            meta: {
                title: "Registration"
            }
        },
        {
            path: "/reset-password",
            name: "forgot-password-page",
            component: ForgotPassword,
            meta: {
                title: "Forgot Password"
            }
        },
        {
            path: "/password-expired",
            name: "password-expired-page",
            component: PasswordExpired,
            meta: {
                title: "Password expired"
            }
        },
        {
            path: "/thank-you-for-registering",
            name: "thank-you-for-registering",
            component: ThankYouForRegistering,
            meta: {
                title: "Thank you for registering"
            }
        },
        {
            path: "/registration-and-login-error",
            name: "registration-and-login-error",
            component: RegistrationAndLoginError,
            meta: {
                title: "Registration and Login Error"
            }
        },
        {
            path: "/password-reset",
            name: "password-reset",
            component: PasswordReset,
            meta: {
                title: "Password Reset"
            }
        },
        {
            path: "/registration-and-login-support",
            name: "registration-and-login-support",
            component: RegistrationAndLoginSupport,
            meta: {
                title: "Registration and Login Support"
            }
        },
        {
            path: "/password-reset-confirm",
            name: "password-reset-confirm",
            component: PasswordResetConfirm,
            props: true,
            meta: {
                title: "Password Reset Confirmation"
            }
        },
        {
            path: "/registration-and-login-support-success",
            name: "registration-and-login-support-success",
            component: RegistrationAndLoginSupportSuccess,
            meta: {
                title: "Registration and Login Support Success"
            }
        },
        {
            path: "/registration-and-login-support-error",
            name: "registration-and-login-support-error",
            component: RegistrationAndLoginSupportError,
            meta: {
                title: "Registration and Login Support Error"
            }
        },
        {
            path: "/dashboard",
            name: "dashboard-page",
            component: Dashboard,
            meta: {
                requiresAuth: true,
                title: "Dashboard"
            }
        },
        {
            path: "/my-documents",
            name: "my-documents",
            component: MyDocuments,
            props: {isPublic: false},
            meta: {
                requiresAuth: true,
                title: "My Documentation"
            }
        },
        {
            path: "/my-admin",
            name: "my-admin",
            component: MyAdmin,
            meta: {
                requiresAuth: true,
                title: "My Admin"
            }
        },
        {
            path: "/my-account",
            name: "my-account",
            component: MyAccount,
            meta: {
                requiresAuth: true,
                title: "My Account"
            }
        },
        {
            path: "/my-support",
            name: "my-support",
            component: Support,
            meta: {
                requiresAuth: true,
                title: "My Support"
            }
        },
        {
            path: "/my-subscription",
            name: "my-subscription",
            component: MySubscription,
            meta: {
                requiresAuth: true,
                title: "My Subscriptions"
            }
        },
        {
            path: "/my-parametric-search",
            name: "my-parametric-search",
            components: {
                default: MyParametricSearch
            },
            meta: {
                requiresAuth: true
            },
            children: [{
                path: '',
                components: {
                    default: MyParametricTable
                },
                meta: {
                    requiresAuth: true,
                    title: "My Parametric Search"
                }
            }, {
                path: 'recommended-driver',
                components: {
                    driver: MyParametricDriver
                },
                meta: {
                    requiresAuth: true,
                    title: "Recommended Driver"
                }
            }, {
                path: 'compare',
                components: {
                    compare: MyParametricCompare
                },
                meta: {
                    requiresAuth: true,
                    title: "Product Comparison"
                }
            }, {
                path: 'demo-board',
                components: {
                    demo: MyParametricDemo
                },
                meta: {
                    requiresAuth: true,
                    title: "Demo Board"
                }
            }]
        }
    ]
});

router.beforeEach((to, from, next) => {
	UserService.getCurrentUser().then(({data}) => {
		const isAuthenticated = typeof (data) !== "undefined";
		if (to.name === 'login-page') {
			if (isAuthenticated) {
				next({name: to.query.redirect || 'dashboard-page'});
			} else {
				store.dispatch(LOGOUT_USER).then(() => {
					Utils.setPageTitle(to);
					Utils.trackPageChange(to);
					next();
				});
			}
		} else if (to.matched.some(record => record.meta.requiresAuth)) {
			if (isAuthenticated) {
				Utils.setPageTitle(to);
				Utils.trackPageChange(to);
				next();
			} else {
				store.dispatch(LOGOUT_USER).then(() => {
					next('/');
				});
			}
		} else {
			Utils.setPageTitle(to);
			Utils.trackPageChange(to);
			next();
		}

		});
});
export default router;

